import { listEmptyStateIntlIds } from './list-empty-state.ids';

export const listEmptyStateLangEnUs = {
  [listEmptyStateIntlIds.title]: `{status, select,
    assigned {Oops! No slots have been reserved or assigned yet}
    not_assigned {Oops! No slots here at the moment}
    other {}
  }`,
  [listEmptyStateIntlIds.description]: `{status, select,
    assigned {As soon as a Rider reserves or is assigned to a slot, it will appear here, okay?}
    not_assigned {When new slots are created for this hub, they'll show up here, okay?}
    other {}
  }`,

  [listEmptyStateIntlIds.filteredList.title]:
    'Oops! We couldn’t find any slots with the applied filters',
  [listEmptyStateIntlIds.filteredList.description]:
    'Review the applied filters or clear them and try again',
  [listEmptyStateIntlIds.filteredList.clearFiltersButton.label]: 'Clear search',
};
